import * as React from "react";
import { Avatar, Button, Flex, Image, Label, Segment, Text } from "@fluentui/react-northstar";
import { initializeIcons, Icon } from '@fluentui/react';
import { withTranslation, WithTranslation } from "react-i18next";
import { CommonHelper } from '../../../helpers/common-helper';

interface IQueueNaFilaProps extends WithTranslation {
    botWriting1: boolean;
    appConfigs: any;
    meetingData: any;
    meetingQueueData: any;
    assuntoSelected: string;
    renderAssuntos: any;
}

const QueueNaFilaCard: React.FunctionComponent<IQueueNaFilaProps> = props => {
    const localize = props.t;

    initializeIcons();

    return (
        <React.Fragment>
            <Flex gap="gap.large" styles={{ margin: "4rem 0" }}>
                <Avatar icon={<Image src="/images/logo.png" />} />
                <Image hidden={!props.botWriting1} className="typing" src="/images/typing.gif" />
                <Flex.Item grow>
                    <Segment
                        hidden={props.botWriting1}
                        className="dialog2"
                        color="brand"
                        content={
                            <Flex gap="gap.large" column>
                                <Text weight="bold" size="large" content={localize("VoceEstaNaFila")} />

                                <Flex>
                                    <Flex column>
                                        <Label
                                            className="positionLabel"
                                            content={(
                                                <Flex column>
                                                    <Text align="center" styles={{ fontSize: '60px' }} weight="bold" size="largest" content={props.meetingQueueData.queuePosition} />
                                                    <Text align="center" weight="light" size="medium" content={localize("SuaPosicao")} />
                                                    <Text align="center" styles={{ marginTop: "10px", fontSize: '1.3rem' }} weight="light" content={
                                                        <Flex>
                                                            <Icon className="margin-style info-icon" iconName="Info" />
                                                            <Text content={`${localize("Protocolo")}: #${props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}`} />
                                                        </Flex>
                                                    } />

                                                </Flex>
                                            )}
                                        />
                                        <Label
                                            className="peopleLabel"
                                            content={(
                                                <Flex column>
                                                    <Text align="center" styles={{ fontSize: '30px', marginTop: "6px" }} weight="bold" size="largest" content={props.meetingQueueData.queues} />
                                                    <Text weight="light" size="smaller" content={localize("PessoasNaFila")} />
                                                </Flex>
                                            )}
                                        />
                                    </Flex>

                                    {props.appConfigs && props.appConfigs.imgQueue != "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src={props.appConfigs.imgQueue} />
                                        </Flex.Item>
                                    }

                                    {props.appConfigs && props.appConfigs.imgQueue == "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src="/images/fila.svg" className="filaImg" />
                                        </Flex.Item>
                                    }
                                </Flex>

                                {props.meetingData?.assuntos && props.meetingData?.assuntos?.length > 0 &&
                                    <Flex gap="gap.smaller" column>
                                        <Text weight="bold" size="large" content={localize("AssuntoAtendimentoFila")} />

                                        {props.assuntoSelected == null &&
                                            <React.Fragment>
                                                <Text weight="light" size="medium" content={localize("SelecioneAssunto")} />

                                                <div className="assunto-buttons">
                                                    {props.meetingData.assuntos.map(props.renderAssuntos)}
                                                </div>
                                            </React.Fragment>
                                        }
                                        {props.assuntoSelected != null &&
                                            <Text weight="light" size="medium" content={<React.Fragment><div><span style={{ fontWeight: 'bold' }}>{props.assuntoSelected}</span> {localize("SelecionadoObrigado")}</div></React.Fragment>} />
                                        }

                                    </Flex>
                                }

                            </Flex>
                        }
                    />
                </Flex.Item>
            </Flex>

            {props.meetingData.bookingsUrl &&
                <Flex gap="gap.large" styles={{ margin: "4rem 0" }}>
                    <Avatar icon={<Image src="/images/logo.png" />} />
                    <Image hidden={!props.botWriting1} className="typing" src="/images/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting1}
                            className="dialog2"
                            color="brand"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text weight="bold" size="large" content={localize("Agendamento")} />

                                    <Flex gap="gap.smaller" column>
                                        {props.appConfigs && props.appConfigs.agendamentoQueueText == "" &&
                                            <Text weight="light" size="medium" content={localize("AgendamentoDescricao")} />
                                        }

                                        {props.appConfigs && props.appConfigs.agendamentoQueueText != "" &&
                                            <Text weight="light" size="medium" content={props.appConfigs.agendamentoQueueText} />
                                        }

                                        <Button content={localize("FazerAgendamento")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.meetingData.bookingsUrl), "_blank")} />
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }
        </React.Fragment>
    );
};

const queueNaFilaWithTranslation = withTranslation()(QueueNaFilaCard);
export default queueNaFilaWithTranslation;